import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const EnergyBrandIcon = observer(
    'EnergyBrandIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='32'
            height='32'
            viewBox='0 0 32 32'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g>
                <path
                    d='M19.3542 17.6027L10.6558 2.49173L4.40796 31.0002L12.2673 16.1049L21.1617 32L27.5919 3.05176e-05L19.3542 17.6027Z'
                    fill='#E8E337'
                />
            </g>
        </SvgElement>
    )
);
